export const formatSearchScore = (score: number | undefined | null): string => {
  if (score === undefined || score === null || !Number.isFinite(score)) {
    return "-";
  }

  if (score >= 0 && score <= 1) {
    return `${Math.round(score * 100)}%`;
  }

  return `${Math.round(score)}`;
};
